import produce from 'immer';
export const initialState = {
  medias: [],
  isLoading: false,
  loadFailed: false,
  loadSuccess: false,
  canLoadMore: false,
  shouldLoadMore: false
};
export const mediaSearchReducer = (state, action) => produce(state, draft => {
  switch (action.type) {
    case 'search-start':
      {
        draft.medias = [];
        draft.isLoading = true;
        draft.loadFailed = false;
        return draft;
      }
    case 'search-success':
      {
        draft.isLoading = false;
        draft.loadFailed = false;
        draft.loadSuccess = true;
        draft.mediaResult = action.result;
        draft.medias = action.result?.results ?? [];
        draft.canLoadMore = !!action.result?.next;
        return draft;
      }
    case 'search-failed':
      {
        draft.isLoading = false;
        draft.loadFailed = true;
        draft.canLoadMore = false;
        return draft;
      }
    case 'load-more':
      {
        if (draft.canLoadMore && !state.isLoading) {
          draft.shouldLoadMore = true;
        }
        return draft;
      }
    case 'load-more-start':
      {
        draft.isLoading = true;
        draft.loadFailed = false;
        return draft;
      }
    case 'load-more-success':
      {
        draft.isLoading = false;
        draft.loadFailed = false;
        draft.loadSuccess = true;
        draft.shouldLoadMore = false;
        draft.canLoadMore = !!action.result.next;
        if (draft.mediaResult) {
          draft.mediaResult.results = [...draft.mediaResult.results, ...action.result.results];
          draft.mediaResult.next = action.result.next;
        }
        draft.medias = [...draft.medias, ...action.result.results];
        return draft;
      }
    case 'load-more-failed':
      {
        draft.isLoading = false;
        draft.loadFailed = true;
        draft.shouldLoadMore = false;
        draft.canLoadMore = false;
        return draft;
      }
    default:
      return draft;
  }
});